import React, { useState, useEffect } from 'react';
import { Search, MapPin, Award, Star } from 'lucide-react';

interface NursingCollege {
  id: number;
  name: string;
  shortName?: string;
  location: string;
  state: string;
  type: 'Government' | 'Private';
  approvals: string[];
  rating?: number;
  reviewCount?: number;
  courses: string[];
  phone?: string;
  email?: string;
  address?: string;
  bestIn?: string;
}

const nursingColleges: NursingCollege[] = [
  // Government Colleges
  {
    id: 1,
    name: "Annamalai University",
    shortName: "AU",
    location: "Annamalainagar",
    state: "Tamil Nadu",
    type: "Government",
    approvals: ["UGC", "NAAC"],
    rating: 4.2,
    reviewCount: 185,
    courses: ["B.Sc. (Nursing)", "Diploma in General Nursing and Midwifery (G.N.M.)", "M.Sc. (Nursing)"],
    phone: "(04144) 232282, 238248, 238027, 238259",
    email: "(04144) 238080",
    address: "Annamalainagar, Cuddalore, Tamil Nadu",
    bestIn: "Research"
  },
  {
    id: 2,
    name: "IRT Perundurai Medical College",
    shortName: "IRTPMC",
    location: "Perundurai",
    state: "Tamil Nadu",
    type: "Government",
    approvals: ["TNMC"],
    rating: 4.0,
    reviewCount: 92,
    courses: ["Diploma in General Nursing and Midwifery (G.N.M.)"],
    phone: "(04294) 220910",
    email: "(04294) 220226",
    address: "Perundurai, Erode, Tamil Nadu",
    bestIn: "Clinical Training"
  },
  {
    id: 3,
    name: "The Tamil Nadu Dr. M.G.R. Medical University",
    shortName: "TNMGRMU",
    location: "Chennai",
    state: "Tamil Nadu",
    type: "Government",
    approvals: ["UGC"],
    rating: 4.5,
    reviewCount: 245,
    courses: ["B.Sc. (Nursing)", "M.Sc. (Nursing)", "M.Sc. (Medical Surgical Nursing)"],
    phone: "(044) 22353574, 22353576 to 79, 22301760 to 63",
    email: "(044) 22353698",
    address: "No. 69, Anna Salai, Guindy, Chennai, Tamil Nadu",
    bestIn: "Academic Excellence"
  },
  {
    id: 4,
    name: "Thoothukudi Government Medical College",
    shortName: "TGMC",
    location: "Thoothukudi",
    state: "Tamil Nadu",
    type: "Government",
    approvals: ["TNMC"],
    rating: 3.8,
    reviewCount: 76,
    courses: ["Diploma in General Nursing and Midwifery (G.N.M.)"],
    phone: "(0462) 2392698, 2310122",
    email: "(0462) 2310122",
    address: "Thoothukudi, Tamil Nadu",
    fees: "₹ 18,000",
    bestIn: "Government Facilities"
  },
  // Private Colleges
  {
    id: 5,
    name: "Adhiparasakthi College of Nursing",
    shortName: "ACN",
    location: "Melmaruvathur",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.9,
    reviewCount: 134,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Melmaruvathur, Kancheepuram-603319",
    fees: "₹ 85,000",
    bestIn: "Infrastructure"
  },
  {
    id: 6,
    name: "KG College of Nursing",
    shortName: "KGCN",
    location: "Coimbatore",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 4.1,
    reviewCount: 98,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "KG Hospital, No.2, Arts College Road, Coimbatore – 641 018",
    fees: "₹ 92,000",
    bestIn: "Placements"
  },
  {
    id: 7,
    name: "Almighty College of Nursing",
    shortName: "ACN",
    location: "Tirunelveli",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.7,
    reviewCount: 65,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Thoothukudi Main Road, Ariyakulam, Maharaja Nagar Post, Tirunelveli-627 351",
    fees: "₹ 78,000",
    bestIn: "Clinical Training"
  },
  {
    id: 8,
    name: "Annai College of Nursing",
    shortName: "ACN",
    location: "Kumbakonam",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.6,
    reviewCount: 45,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Anakudi Road, Kovilacheri, Kumbakonam-612503",
    fees: "₹ 75,000",
    bestIn: "Faculty"
  },
  {
    id: 9,
    name: "Annai JKK. Sampoorani Ammal College of Nursing",
    shortName: "JKKSACN",
    location: "Namakkal",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.8,
    reviewCount: 72,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Ethirmedu, Valayakaranur Post, Komarapalayam, Namakkal –638 183",
    fees: "₹ 82,000",
    bestIn: "Research"
  },
  {
    id: 10,
    name: "Annai Veilankanni's College of Nursing",
    shortName: "AVCN",
    location: "Chennai",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 4.0,
    reviewCount: 116,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "33, Gandhi Road, Nedungundram Village, Komapakkam Post Chennai - 600 048",
    fees: "₹ 95,000",
    bestIn: "Location"
  },
  {
    id: 11,
    name: "Bishop's College of Nursing",
    shortName: "BCN",
    location: "Dharapuram",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.9,
    reviewCount: 58,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "C.S.I. Mission Compound, Dharapuram - 638 656, Thirupur District",
    fees: "₹ 72,000",
    bestIn: "Community Service"
  },
  {
    id: 12,
    name: "CSI. Jeyaraj Annapackiam College of Nursing",
    shortName: "CJACN",
    location: "Madurai",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 4.2,
    reviewCount: 89,
    courses: ["B.Sc. (Nursing)", "M.Sc. (Nursing)"],
    address: "Merry Dew Hills, Jonespuram, Pasumalai, Madurai – 625 004",
    fees: "₹ 88,000",
    bestIn: "Academic Excellence"
  },
  {
    id: 13,
    name: "Cherrann's College of Nursing",
    shortName: "CCN",
    location: "Coimbatore",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.5,
    reviewCount: 42,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "521, Perur Main Road, Telungupalayam Pirivu, Coimbatore-641039",
    fees: "₹ 76,000",
    bestIn: "Infrastructure"
  },
  {
    id: 14,
    name: "Dhanalakshmi Srinivasan College of Nursing",
    shortName: "DSCN",
    location: "Perambalur",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.7,
    reviewCount: 67,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "274-C, Thuraiyur Road, Perambalaur - 621 212",
    fees: "₹ 79,000",
    bestIn: "Faculty"
  },
  {
    id: 15,
    name: "Excel Nursing College",
    shortName: "ENC",
    location: "Namakkal",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.6,
    reviewCount: 53,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Ranganoor Road, Pallakkapalayam Village, Sankari West Post, Komarapalayam Taluk, Namakkal – 637303",
    fees: "₹ 74,000",
    bestIn: "Placements"
  },
  {
    id: 16,
    name: "P.S.G. College of Nursing",
    shortName: "PSGCN",
    location: "Coimbatore",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC", "NAAC"],
    rating: 4.3,
    reviewCount: 156,
    courses: ["B.Sc. (Nursing)", "M.Sc. (Nursing)", "G.N.M."],
    address: "Avinashi Road, Peelamedu, Coimbatore-641 004",
    fees: "₹ 110,000",
    bestIn: "Academic Excellence"
  },
  {
    id: 17,
    name: "Sri Ramakrishna College of Nursing",
    shortName: "SRCN",
    location: "Coimbatore",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 4.1,
    reviewCount: 132,
    courses: ["B.Sc. (Nursing)", "M.Sc. (Nursing)"],
    address: "395, Sarojini Naidu Road, Sidhapudur, Coimbatore-641044",
    fees: "₹ 98,000",
    bestIn: "Infrastructure"
  },
  {
    id: 18,
    name: "KMCH College of Nursing",
    shortName: "KMCHCN",
    location: "Coimbatore",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 4.0,
    reviewCount: 108,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "S.F. No. 259 & 267, Kalapatti Village, Coimbatore North Taluk, Coimbatore – 641 048",
    fees: "₹ 105,000",
    bestIn: "Clinical Training"
  },
  {
    id: 19,
    name: "Tagore College of Nursing",
    shortName: "TCN",
    location: "Chennai",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.9,
    reviewCount: 87,
    courses: ["B.Sc. (Nursing)", "M.Sc. (Nursing)"],
    address: "Tagore Medical College & Hospital Campus, Rathinamangalam, Melakkottaiyur Post, Chennai 600 127",
    fees: "₹ 96,000",
    bestIn: "Research"
  },
  {
    id: 20,
    name: "Karpaga Vinayaga College of Nursing",
    shortName: "KVCN",
    location: "Pudukkottai",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.5,
    reviewCount: 48,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "J.J. Nagar, Sivapuram, Namanasamudram Post, Pudukkottai - 622 422",
    fees: "₹ 73,000",
    bestIn: "Rural Healthcare"
  },
  {
    id: 21,
    name: "Karpaga Vinayaga College of Nursing",
    shortName: "KVCN-2",
    location: "Kancheepuram",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.6,
    reviewCount: 52,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "G.S.T. Road, Moosivakam, Chinna Kolambakkam, Palayanoor (P.O), Padalam (Via), Maduranthakam, Kancheepuram District- 603 308",
    fees: "₹ 76,000",
    bestIn: "Infrastructure"
  },
  {
    id: 22,
    name: "Karpagam Nursing College",
    shortName: "KNC",
    location: "Coimbatore",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.9,
    reviewCount: 87,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "S.F.No. 770,763, Othakkalmandapamvillage, Coimbatore – 641 032",
    fees: "₹ 89,000",
    bestIn: "Academic Excellence"
  },
  {
    id: 23,
    name: "Krishna College of Paramedical And Allied Health Science",
    shortName: "KCPAHS",
    location: "Trichy",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.4,
    reviewCount: 35,
    courses: ["B.Sc. (Nursing)", "G.N.M.", "Paramedical"],
    address: "Kottaimedu, Inam Samayapuram, Manachanallur (Taluk), Trichy 621 105",
    fees: "₹ 68,000",
    bestIn: "Allied Health"
  },
  {
    id: 24,
    name: "Madha College of Nursing",
    shortName: "MCN",
    location: "Chennai",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.8,
    reviewCount: 94,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Somangalam Road, Kundrathur, Chennai - 600 069",
    fees: "₹ 91,000",
    bestIn: "Clinical Training"
  },
  {
    id: 25,
    name: "Mailam Nursing College",
    shortName: "MNC",
    location: "Villupuram",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.3,
    reviewCount: 28,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Mailam Post Tindivanam Taluk, Villupuram Dist. 604304",
    fees: "₹ 65,000",
    bestIn: "Community Service"
  },
  {
    id: 26,
    name: "Matha College of Nursing",
    shortName: "MCN",
    location: "Sivagangai",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.5,
    reviewCount: 41,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Annavasal Road, Vaanpuram, Manamadurai - 630 603, Sivagangai District",
    fees: "₹ 71,000",
    bestIn: "Faculty"
  },
  {
    id: 27,
    name: "Mohamed Sathak A.J. College of Nursing",
    shortName: "MSAJCN",
    location: "Chennai",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.7,
    reviewCount: 83,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "No.34, Rajiv Gandhi Salai (Omr), It Highway, Siruseri, Egattur, Kanchipuram District",
    fees: "₹ 94,000",
    bestIn: "Technology Integration"
  },
  {
    id: 28,
    name: "Mother Teresa College of Nursing",
    shortName: "MTCN",
    location: "Pudukottai",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.6,
    reviewCount: 59,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Mettusalai, Illupur Post, Pudukottai-622102",
    fees: "₹ 77,000",
    bestIn: "Community Care"
  },
  {
    id: 29,
    name: "Mullai College of Nursing",
    shortName: "MCN",
    location: "Dharmapuri",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.4,
    reviewCount: 37,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "S.F. No. 81/1A,1B,2A,2B, Gandhi Nagar, Mampatty, Pappinayakan Valasai Village, Dharmapuri District-636902",
    fees: "₹ 69,000",
    bestIn: "Rural Training"
  },
  {
    id: 30,
    name: "Nandha College of Nursing",
    shortName: "NCN",
    location: "Erode",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.8,
    reviewCount: 76,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Koorapalayam Pirivu, Pitchandampalayam Post, Erode 638 052",
    fees: "₹ 84,000",
    bestIn: "Placements"
  },
  {
    id: 31,
    name: "Gem Institute of Nursing Education And Research",
    shortName: "GINER",
    location: "Coimbatore",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.5,
    reviewCount: 44,
    courses: ["B.Sc. (Nursing)", "G.N.M.", "Research"],
    address: "4/146 Peedampalli, Via-Ondipudur, Coimbatore District",
    fees: "₹ 78,000",
    bestIn: "Research"
  },
  {
    id: 32,
    name: "Indira College of Nursing",
    shortName: "ICN",
    location: "Thiruvallur",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.3,
    reviewCount: 31,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "1,Vgr Nagar, Vgr Garden, Pandur – 631 203, Thiruvallur District",
    fees: "₹ 67,000",
    bestIn: "Affordable Education"
  },
  {
    id: 33,
    name: "J.K. College of Nursing And Paramedicals",
    shortName: "JKCNP",
    location: "Coimbatore",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.6,
    reviewCount: 55,
    courses: ["B.Sc. (Nursing)", "G.N.M.", "Paramedical"],
    address: "S.F. No.90 Kamaraj Road, Next To Esi Hospital, Uppillipalayam, Coimbatore - 641 015",
    fees: "₹ 82,000",
    bestIn: "Paramedical Training"
  },
  {
    id: 34,
    name: "Nehru College of Nursing and Research Institute",
    shortName: "NCNRI",
    location: "Coimbatore",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.7,
    reviewCount: 68,
    courses: ["B.Sc. (Nursing)", "M.Sc. (Nursing)", "Research"],
    address: "S.F.No. 45/1B, Thirumalayampalayam Village, Coimbatore District - 641 105",
    fees: "₹ 86,000",
    bestIn: "Research Excellence"
  },
  {
    id: 35,
    name: "P.P.G. College of Nursing",
    shortName: "PPGCN",
    location: "Coimbatore",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.9,
    reviewCount: 91,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "9/1, Keeranatham Road, Saravanampatty, Coimbatore - 641 035",
    fees: "₹ 88,000",
    bestIn: "Clinical Excellence"
  },
  {
    id: 36,
    name: "Padmavathi College of Nursing",
    shortName: "PCN",
    location: "Dharmapuri",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.4,
    reviewCount: 39,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Post Box No:15, Krishnagiri Main Road, Periyanahalli, Dharmapuri - 635 205",
    fees: "₹ 70,000",
    bestIn: "Rural Healthcare"
  },
  {
    id: 37,
    name: "Pachamuthu College of Nursing",
    shortName: "PCN",
    location: "Dharmapuri",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.5,
    reviewCount: 46,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "178/3a Muthupatti, Hale Dharmapuri Post, Krishnagiri Main Road, Dharmapuri Dist 636701",
    fees: "₹ 72,000",
    bestIn: "Community Service"
  },
  {
    id: 38,
    name: "PGP. College of Nursing & Research",
    shortName: "PGPCNR",
    location: "Namakkal",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.6,
    reviewCount: 63,
    courses: ["B.Sc. (Nursing)", "M.Sc. (Nursing)", "Research"],
    address: "NH-7, Karur Main Road, Namakkal District – 637 207",
    fees: "₹ 79,000",
    bestIn: "Research Programs"
  },
  {
    id: 39,
    name: "R.V.S. College of Nursing",
    shortName: "RVSCN",
    location: "Coimbatore",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.8,
    reviewCount: 85,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Sulur, 242 B, Trichy Road, Sulur, Coimbatore 641 402",
    fees: "₹ 87,000",
    bestIn: "Infrastructure"
  },
  {
    id: 40,
    name: "Revathi College of Nursing",
    shortName: "RCN",
    location: "Tirupur",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.5,
    reviewCount: 51,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "2/718- 2/718-4, Pookattupalayam, Velayuthampalayam Post, Avinashi Taluk, Tirupur District - 641654",
    fees: "₹ 75,000",
    bestIn: "Student Support"
  },
  {
    id: 41,
    name: "Sacred Heart Nursing College",
    shortName: "SHNC",
    location: "Madurai",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 4.0,
    reviewCount: 102,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Ultra Trust, 4/235, College Road, Thasildar Nagar, Madurai – 625 020",
    fees: "₹ 93,000",
    bestIn: "Spiritual Care"
  },
  {
    id: 42,
    name: "Sardar Rajas College of Nursing",
    shortName: "SRCN",
    location: "Tirunelveli",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.7,
    reviewCount: 64,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Thirurajapuram Kavalkinaru Junction, Kavalkinaru Post, Tirunelveli – 627 105",
    fees: "₹ 81,000",
    bestIn: "Clinical Training"
  },
  {
    id: 43,
    name: "Sengunthar College of Nursing",
    shortName: "SCN",
    location: "Namakkal",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.6,
    reviewCount: 57,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Mandagapalayam, Village, Tiruchengode Taluk, Namakkal District - 637 205",
    fees: "₹ 78,000",
    bestIn: "Community Health"
  },
  {
    id: 44,
    name: "Shanmuga College of Nursing",
    shortName: "SCN",
    location: "Salem",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.8,
    reviewCount: 73,
    courses: ["B.Sc. (Nursing)", "G.N.M.", "Paramedical"],
    address: "Shanmuga Institute of Para Medical Sciences, 24 Saradha College Road Salem - 636 007",
    fees: "₹ 85,000",
    bestIn: "Paramedical Integration"
  },
  {
    id: 45,
    name: "Shree Sastha College of Nursing",
    shortName: "SSCN",
    location: "Chennai",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 4.1,
    reviewCount: 118,
    courses: ["B.Sc. (Nursing)", "M.Sc. (Nursing)"],
    address: "Chennai-Bangalore Highway, Sree Sastha Nagar, Chembarabakkam, Chennai-600123",
    fees: "₹ 105,000",
    bestIn: "Academic Excellence"
  },
  {
    id: 46,
    name: "Shri Venkateshwara College of Nursing",
    shortName: "SVCN",
    location: "Erode",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.5,
    reviewCount: 42,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Othkuthirai, K.Mettupalayam (P.O), Gobichettipalayam-638455, Erode District",
    fees: "₹ 74,000",
    bestIn: "Rural Training"
  },
  {
    id: 47,
    name: "SNS College of Nursing",
    shortName: "SNSCN",
    location: "Coimbatore",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.9,
    reviewCount: 96,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "SNS Kalvi Nagar, Sathy Main Road, Saravanampatti Post, Coimbatore – 641 035",
    fees: "₹ 92,000",
    bestIn: "Technology"
  },
  {
    id: 48,
    name: "Sree Abirami College of Nursing",
    shortName: "SACN",
    location: "Coimbatore",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.6,
    reviewCount: 58,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Machegoundanpalayam, Seerapalayam Village, Eachanari post, Coimbatore-641021",
    fees: "₹ 80,000",
    bestIn: "Student Care"
  },
  {
    id: 49,
    name: "Sree Mookambika College of Nursing",
    shortName: "SMCN",
    location: "Kanyakumari",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.7,
    reviewCount: 67,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "V.P.M. Hospital Complex, Padanilam, Kulasekharam, Kanyakumari-629161",
    fees: "₹ 83,000",
    bestIn: "Hospital Integration"
  },
  {
    id: 50,
    name: "Sresakthimayeil Institute of Nursing & Research",
    shortName: "SINR",
    location: "Namakkal",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.8,
    reviewCount: 79,
    courses: ["B.Sc. (Nursing)", "M.Sc. (Nursing)", "Research"],
    address: "Natarajapuram, NH–47, Komarapalayam, Namakkal - 638 183. (J.K.K. Nataraja)",
    fees: "₹ 86,000",
    bestIn: "Research Excellence"
  },
  {
    id: 51,
    name: "Sri Vijay Vidyalaya College of Nursing",
    shortName: "SVVCN",
    location: "Dharmapuri",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.4,
    reviewCount: 36,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Gandhi Nagar, Dharmapuri-636807",
    fees: "₹ 69,000",
    bestIn: "Affordable Education"
  },
  {
    id: 52,
    name: "Srinivasan College of Nursing",
    shortName: "SCN",
    location: "Perambalur",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.6,
    reviewCount: 61,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Siruvachur, Perambalur - 621 113",
    fees: "₹ 77,000",
    bestIn: "Clinical Training"
  },
  {
    id: 53,
    name: "Srinivasan Nursing College",
    shortName: "SNC",
    location: "Trichy",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.7,
    reviewCount: 74,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "NH 45 Trichy Chennai Trunk Road, Samayapuram, Trichy 621 112",
    fees: "₹ 82,000",
    bestIn: "Highway Access"
  },
  {
    id: 54,
    name: "SRM Trichy College of Nursing",
    shortName: "SRMTCN",
    location: "Tiruchirappalli",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC", "NAAC"],
    rating: 4.2,
    reviewCount: 145,
    courses: ["B.Sc. (Nursing)", "M.Sc. (Nursing)"],
    address: "Irungalur Village & Post, Manachannallur Taluk, Tiruchirappalli District – 621 105",
    fees: "₹ 115,000",
    bestIn: "Brand Value"
  },
  {
    id: 55,
    name: "St.Mariam College of Nursing",
    shortName: "SMCN",
    location: "Tirunelveli",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.9,
    reviewCount: 88,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Tenkasi -Tirunelveli Main Road, Puthur Village, Tirunelveli Dist 627851",
    fees: "₹ 89,000",
    bestIn: "Spiritual Values"
  },
  {
    id: 56,
    name: "The Kaavery Nursing College",
    shortName: "TKNC",
    location: "Salem",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.8,
    reviewCount: 82,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "M.Kalipatti post, Mettur Taluk, Salem-636453",
    fees: "₹ 84,000",
    bestIn: "Hospital Network"
  },
  {
    id: 57,
    name: "United College of Nursing",
    shortName: "UCN",
    location: "Coimbatore",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.5,
    reviewCount: 47,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Gudalur Town Panchayat, Periyanayakenpalayam, Coimbatore-641020",
    fees: "₹ 76,000",
    bestIn: "Unity in Diversity"
  },
  {
    id: 58,
    name: "V.P.M.M College of Nursing",
    shortName: "VPMMCN",
    location: "Virudhunagar",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.6,
    reviewCount: 54,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Krishnan Koil, Srivilliputtur, Virudhunagar-626190",
    fees: "₹ 78,000",
    bestIn: "Traditional Values"
  },
  {
    id: 59,
    name: "Velammal College of Nursing",
    shortName: "VCN",
    location: "Madurai",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 4.0,
    reviewCount: 112,
    courses: ["B.Sc. (Nursing)", "M.Sc. (Nursing)"],
    address: "Velammal Village, Madurai-Tuticorin Ring Road, Anuppanadi, Madurai – 625 009",
    fees: "₹ 98,000",
    bestIn: "Brand Recognition"
  },
  {
    id: 60,
    name: "Vellalar College of Nursing",
    shortName: "VCN",
    location: "Erode",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.7,
    reviewCount: 69,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Maruthi Nagar, Thindal Post, Erode-638012",
    fees: "₹ 81,000",
    bestIn: "Community Focus"
  },
  {
    id: 61,
    name: "Venkateswara Nursing College",
    shortName: "VNC",
    location: "Kancheepuram",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.8,
    reviewCount: 76,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "OMR Road, Thalambur 603103, Kancheepuram District",
    fees: "₹ 87,000",
    bestIn: "IT Corridor Location"
  },
  {
    id: 62,
    name: "Vivekanandha College of Nursing",
    shortName: "VCN",
    location: "Tiruchengode",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.8,
    reviewCount: 74,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "Elayampalayam, Tiruchengode, Namakkal - 637 205 (Angammal Trust)",
    fees: "₹ 81,000",
    bestIn: "Community Outreach"
  },
  {
    id: 63,
    name: "Vivekananda Nursing College For Women",
    shortName: "VNCFW",
    location: "Salem",
    state: "Tamil Nadu",
    type: "Private",
    approvals: ["INC", "TNMC"],
    rating: 3.6,
    reviewCount: 58,
    courses: ["B.Sc. (Nursing)", "G.N.M."],
    address: "NH-47, Kovai Salem Express High Way, Veerachipalayam - 637 303, Sankari Taluk, Salem (Rabindranath Tagore Trust)",
    fees: "₹ 79,000",
    bestIn: "Women Empowerment"
  }
];

const NursingPage: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState<'name' | 'rating'>('name');
  const [filterByType, setFilterByType] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [itemsToShow, setItemsToShow] = useState(10);
  const maxItemsPerLoad = 20;

  // Debounce search term to prevent performance issues
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  try {
    // Ensure unique IDs for all colleges to prevent rendering issues
    const collegesWithUniqueIds = nursingColleges.map((college, index) => ({
      ...college,
      id: index + 1 // Assign sequential IDs starting from 1
    }));

    // Filter colleges based on search and filters using debounced search
    const filteredColleges = collegesWithUniqueIds.filter(college => {
      try {
        const matchesSearch = !debouncedSearchTerm || 
                             college.name?.toLowerCase().includes(debouncedSearchTerm.toLowerCase()) ||
                             college.location?.toLowerCase().includes(debouncedSearchTerm.toLowerCase()) ||
                             college.courses?.some(course => course.toLowerCase().includes(debouncedSearchTerm.toLowerCase()));
        const matchesType = filterByType === '' || college.type === filterByType;
        return matchesSearch && matchesType;
      } catch (error) {
        console.error('Error filtering college:', college, error);
        return false;
      }
    });

    // Sort colleges
    const sortedColleges = [...filteredColleges].sort((a, b) => {
      if (sortBy === 'rating') {
        return (b.rating || 0) - (a.rating || 0);
      } else {
        return a.name.localeCompare(b.name);
      }
    });

    // Manual pagination for better performance with large datasets
    const itemsPerPage = 10; // Show 10 items per page
    const [currentPage, setCurrentPage] = useState(1);
    
    // Calculate pagination values
    const totalItems = sortedColleges.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
    const paginatedColleges = sortedColleges.slice(startIndex, endIndex);

    // Pagination handlers with loading state for better UX
    const handleNextPage = () => {
      if (currentPage < totalPages) {
        setIsLoading(true);
        setTimeout(() => {
          setCurrentPage(currentPage + 1);
          setIsLoading(false);
        }, 50);
      }
    };

    const handlePrevPage = () => {
      if (currentPage > 1) {
        setIsLoading(true);
        setTimeout(() => {
          setCurrentPage(currentPage - 1);
          setIsLoading(false);
        }, 50);
      }
    };

    const goToPage = (page: number) => {
      if (page >= 1 && page <= totalPages && page !== currentPage) {
        setIsLoading(true);
        setTimeout(() => {
          setCurrentPage(page);
          setIsLoading(false);
        }, 50);
      }
    };

    // Reset to first page when filters change
    useEffect(() => {
      setIsLoading(true);
      // Add a small delay to show loading state
      const timer = setTimeout(() => {
        setCurrentPage(1);
        setIsLoading(false);
      }, 100);
      
      return () => clearTimeout(timer);
    }, [debouncedSearchTerm, filterByType, sortBy]);

    return (
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Nursing Colleges in Tamil Nadu
            </h1>
            <p className="text-lg text-gray-600">
              Discover the best nursing colleges for your career in healthcare
            </p>
            <div className="mt-4 flex items-center justify-center space-x-4 text-sm text-gray-500">
              <span className="flex items-center">
                <span className="w-3 h-3 bg-green-500 rounded-full mr-2"></span>
                Government ({collegesWithUniqueIds.filter(c => c.type === 'Government').length})
              </span>
              <span className="flex items-center">
                <span className="w-3 h-3 bg-blue-500 rounded-full mr-2"></span>
                Private ({collegesWithUniqueIds.filter(c => c.type === 'Private').length})
              </span>
              <span className="flex items-center">
                <span className="w-3 h-3 bg-gray-400 rounded-full mr-2"></span>
                Total: {collegesWithUniqueIds.length} colleges
              </span>
            </div>
          </div>

          {/* Search and Filter Controls */}
          <div className="mb-6 bg-white p-6 rounded-lg shadow-sm">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* Search */}
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
                <input
                  type="text"
                  placeholder="Search colleges, locations, courses..."
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              {/* Type Filter */}
              <select
                title="Filter by college type"
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={filterByType}
                onChange={(e) => {
                  setIsLoading(true);
                  setFilterByType(e.target.value);
                }}
                disabled={isLoading}
              >
                <option value="">All Types</option>
                <option value="Government">Government</option>
                <option value="Private">Private</option>
              </select>

              {/* Sort */}
              <select
                title="Sort colleges by"
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={sortBy}
                onChange={(e) => {
                  setIsLoading(true);
                  setSortBy(e.target.value as 'name' | 'rating');
                }}
                disabled={isLoading}
              >
                <option value="name">Sort by Name</option>
                <option value="rating">Sort by Google Rating</option>
              </select>
            </div>
          </div>

          {/* Results Summary */}
          <div className="mb-4 text-sm text-gray-600">
            Showing {startIndex + 1}-{endIndex} of {totalItems} nursing colleges
            {debouncedSearchTerm && ` for "${debouncedSearchTerm}"`}
            {filterByType && ` (${filterByType} only)`}
          </div>

          {/* Colleges Table */}
          <div className="bg-white shadow-sm rounded-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      College Details
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Location
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Courses & Fees
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Rating
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Approvals
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {isLoading ? (
                    <tr>
                      <td colSpan={5} className="px-6 py-8 text-center">
                        <div className="flex justify-center items-center">
                          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                          <span className="ml-2">Loading colleges...</span>
                        </div>
                      </td>
                    </tr>
                  ) : paginatedColleges && paginatedColleges.length > 0 ? paginatedColleges.map((college: NursingCollege) => (
                    <tr key={college.id} className="hover:bg-gray-50 transition-colors duration-200">
                      {/* College Details */}
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div>
                            <div className="flex items-center gap-2 mb-1">
                              <div className="text-sm font-medium text-gray-900">
                                {college.name || 'N/A'}
                              </div>
                              <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                                college.type === 'Government' 
                                  ? 'bg-green-100 text-green-800' 
                                  : 'bg-blue-100 text-blue-800'
                              }`}>
                                {college.type || 'Unknown'}
                              </span>
                            </div>
                            <div className="text-sm text-gray-500">{college.shortName || 'N/A'}</div>
                            <div className="flex items-center text-xs text-orange-600 mt-1">
                              <Award className="h-3 w-3 mr-1" />
                              {college.bestIn || 'General Excellence'}
                            </div>
                          </div>
                        </div>
                      </td>

                      {/* Location */}
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center text-sm text-gray-900">
                          <MapPin className="h-4 w-4 mr-1 text-gray-400" />
                          <div>
                            <div className="font-medium">{college.location || 'N/A'}</div>
                            <div className="text-gray-500">{college.state || 'N/A'}</div>
                          </div>
                        </div>
                      </td>

                      {/* Courses */}
                      <td className="px-6 py-4">
                        <div className="text-sm text-gray-900">
                          <div className="text-xs text-gray-500">
                            {college.courses?.slice(0, 2).join(', ') || 'N/A'}
                            {college.courses && college.courses.length > 2 && ' +more'}
                          </div>
                        </div>
                      </td>

                      {/* Google Rating */}
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          {college.rating ? (
                            <>
                              <Star className="h-4 w-4 text-yellow-400 fill-current" />
                              <span className="ml-1 text-sm text-gray-900">{college.rating}</span>
                              <span className="ml-1 text-xs text-gray-500">
                                ({college.reviewCount || 0})
                              </span>
                            </>
                          ) : (
                            <span className="text-sm text-gray-500">No rating</span>
                          )}
                        </div>
                      </td>

                      {/* Approvals */}
                      <td className="px-6 py-4">
                        <div className="flex flex-wrap gap-1">
                          {college.approvals && college.approvals.length > 0 ? (
                            college.approvals.slice(0, 3).map((approval, idx) => (
                              <span
                                key={idx}
                                className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800"
                              >
                                {approval}
                              </span>
                            ))
                          ) : (
                            <span className="text-xs text-gray-500">N/A</span>
                          )}
                        </div>
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan={5} className="px-6 py-8 text-center text-gray-500">
                        No nursing colleges found matching your criteria.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
              <div className="flex-1 flex justify-between sm:hidden">
                <button
                  onClick={handlePrevPage}
                  disabled={currentPage === 1 || isLoading}
                  className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isLoading ? 'Loading...' : 'Previous'}
                </button>
                <button
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages || isLoading}
                  className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isLoading ? 'Loading...' : 'Next'}
                </button>
              </div>
              
              <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                <div>
                  <p className="text-sm text-gray-700">
                    Showing <span className="font-medium">{startIndex + 1}</span> to{' '}
                    <span className="font-medium">{endIndex}</span> of{' '}
                    <span className="font-medium">{totalItems}</span> results
                  </p>
                </div>
                
                <div className="flex items-center space-x-2">
                  <button
                    onClick={handlePrevPage}
                    disabled={currentPage === 1 || isLoading}
                    className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {isLoading ? 'Loading...' : 'Previous'}
                  </button>
                  
                  <div className="flex space-x-1">
                    {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                      let pageNum;
                      if (totalPages <= 5) {
                        pageNum = i + 1;
                      } else if (currentPage <= 3) {
                        pageNum = i + 1;
                      } else if (currentPage >= totalPages - 2) {
                        pageNum = totalPages - 4 + i;
                      } else {
                        pageNum = currentPage - 2 + i;
                      }
                      
                      return (
                        <button
                          key={pageNum}
                          onClick={() => goToPage(pageNum)}
                          disabled={isLoading}
                          className={`px-3 py-2 text-sm font-medium rounded-md disabled:opacity-50 disabled:cursor-not-allowed ${
                            currentPage === pageNum
                              ? 'bg-blue-600 text-white'
                              : 'text-gray-700 bg-white border border-gray-300 hover:bg-gray-50'
                          }`}
                        >
                          {pageNum}
                        </button>
                      );
                    })}
                  </div>
                  
                  <button
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages || isLoading}
                    className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {isLoading ? 'Loading...' : 'Next'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );

  } catch (error) {
    console.error('Error rendering NursingPage:', error);
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Something went wrong</h2>
          <p className="text-gray-600">Please refresh the page to try again.</p>
        </div>
      </div>
    );
  }
};

export default NursingPage;